"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNTESSchema = void 0;
const zod_1 = require("zod");
const serialised_eventr_date_1 = require("./serialised-eventr-date");
const start_or_end_enum_1 = require("./start-or-end-enum");
const section_1 = require("./section");
/**
 * The Up Next Timeline Entry Source (UNTES) schema defines the content to
 * display in the Up Next iOS widget. Any component (i.e., flight, transport,
 * etc.) is transformed into this schema.
 */
exports.UNTESSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    date: serialised_eventr_date_1.SerialisedEventrDateSchema,
    checkIn: serialised_eventr_date_1.SerialisedEventrDateSchema.optional(),
    primary: zod_1.z.string(),
    secondary: zod_1.z.string().optional(),
    tertiary: zod_1.z.string().optional(),
    bookingReference: zod_1.z.string().optional(),
    section: section_1.SectionEnum,
    subSection: zod_1.z.string().optional(),
    startOrEnd: start_or_end_enum_1.StartOrEndEnum,
})
    .optional();
